import React from 'react';

function Services() {
  const services = [
    {
      title: 'Residence',
      image:
        '/innerpages/assets/img/sector/DB-architekt-homes-sector.jpg',
      desc: 'Designing elegant and functional residential spaces that reflect comfort, lifestyle and modern living.',
      className: 'residence-card',
    },
    {
      title: 'Housing',
      image:
        '/innerpages/assets/img/sector/DB-architekt-housing-Lotus Zing-sector.jpg',
      desc: 'Creating sustainable and thoughtfully planned housing developments for modern communities.',
      className: 'housing-card',
    },
    {
      title: 'Farm House',
      image:
        '/innerpages/assets/img/sector/DB-architekt-architecture-farm house-sector.jpg',
      desc: 'Blending natural aesthetics with luxury and comfort for peaceful farmhouse living experiences.',
      className: 'farmhouse-card',
    },
    {
      title: 'Hospitality',
      image:
        '/innerpages/assets/img/sector/DB-ARCHITEKT-Greenopolis-Club-sector.jpg',
      desc: 'Crafting immersive hospitality environments focused on guest comfort and memorable experiences.',
      className: 'hospitality-card',
    },
    {
      title: 'Institutional',
      image:
        '/innerpages/assets/img/sector/DB ARCHITEKT-HOTEL MANAGEMENT-CLASSROOM-sector.jpg',
      desc: 'Building functional institutional spaces with smart planning, safety and community value.',
      className: 'institutional-card',
    },
    {
      title: 'Corporate Interior',
      image:
        '/innerpages/assets/img/sector/DB-architekt-corporate office-sector.JPG',
      desc: 'Designing productive corporate environments that inspire collaboration and innovation.',
      className: 'corporate-card',
    },
    {
      title: 'Retails and F & B',
      image:
        '/innerpages/assets/img/sector/DB-architekt-tlw-sector.jpg',
      desc: 'Creating engaging retail and dining spaces that elevate customer experience and branding.',
      className: 'retail-card',
    },
    {
      title: 'Industrial Design',
      image:
        '/innerpages/assets/img/services/DB-Architekt-industrial-serctor.jpg',
      desc: 'Developing industrial spaces focused on efficiency, workflow and sustainable operations.',
      className: 'industrial-card',
    },
  ];

  return (
    <section className="db-services-section">
      <div className="container">
        <div className="db-services-heading text-center">

          <h2 className="db-services-title">
            Designing Spaces 
            Across Every Sector
          </h2>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6"
              key={index}
            >
              <div
                className={`db-service-card ${service.className}`}
              >
                <div className="db-service-image">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="img-cover"
                  />

                  <div className="db-service-overlay"></div>
                </div>

                <div className="db-service-content">
                  <div className="db-service-number">
  <img
    src="/innerpages/assets/img/logos/DB-Circle-color-Logo.png"
    alt="logo"
    className="db-service-number-logo"
  />

  {/* <span>{`0${index + 1}`}</span> */}
</div>

                  <h4>{service.title}</h4>

                  <p>{service.desc}</p>

                  <a href="#" className="db-service-btn">
                    Explore More
                    <i className="ti-arrow-top-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#"
            className="db-services-main-btn"
          >
            Let’s Talk
            <i className="ti-arrow-top-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Services;